import { Dinero } from "dinero.js";
import { DataGrid } from "@material-ui/data-grid";
import * as React from "react";
import { useHistory, useLocation } from "react-router";
import { Balance } from "../../../../../services/royalties/types/balance";
import { listBalances } from "../../sdk/royalties";
import { Toolbar, Typography, Input } from "@material-ui/core";

const escapeRegExp = (value: string): string => {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

export const EarningsListPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const [loading, setLoading] = React.useState(false);
  const [size, setSize] = React.useState(0);
  const [balances, setBalances] = React.useState<Balance[]>([]);
  const [page, setPage] = React.useState<Balance[]>([]);
  const [userId, setUserId] = React.useState("");

  React.useEffect(() => {
    setLoading(true);
    listBalances()
      .then((data) => {
        if (data) {
          setBalances(data);
          setPage(data);
          setSize(data.length || 0);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  //const gotoEarnings = () => history.push(`${location.pathname}/${userId}`, location.state);
  
  const requestSearch = () => {
    if (userId.trim() === ""){
      setPage(balances);
      setSize(balances.length);
    }
    const searchRegex = new RegExp(escapeRegExp(userId), 'i');
    const filteredRows = balances.filter((row: any) => {
      return Object.keys(row).some((field: any) => {
        return searchRegex.test(row[field].toString());
      });
    });
    setPage(filteredRows);
    setSize(filteredRows.length || 0);
  };


  return (
    <section>
      <Toolbar variant="dense" style={{ marginTop: "20px" }}>
        <Typography variant="h4" style={{ flexGrow: 1 }}>
          Pending Balances
        </Typography>
        <Input
          placeholder="Lookup user"
          inputProps={{ "aria-label": "search" }}
          style={{ width: "300px" }}
          value={userId}
          onChange={(ev) => setUserId(ev.target.value)}
          onKeyDown={(ev) => (ev.key === "Enter" ? requestSearch(): undefined)}
        />
      </Toolbar>
      <div style={{ display: "flex", height: "750px", marginTop: "20px" }}>
        <DataGrid
          rows={page.map((i) => ({ id: i.userId, ...i }))}
          columns={[
            { field: "name", headerName: "Name", width: 300 },
            { field: "email", headerName: "Email", width: 300 },
            {
              field: "balance",
              headerName: "Balance",
              width: 300,
              type: "number",
              valueFormatter: (params) => (params.value as Dinero).toFormat(),
            },
          ]}
          pagination
          pageSize={10}
          rowCount={size}
          paginationMode="client"
          loading={loading}
          onRowClick={(params, ev) => {
            const url = `${location.pathname}/${params.row.userId}`;
            if (ev.ctrlKey || ev.metaKey) {
              window.open(url, '_blank')
            } else {
              history.push(url, location.state)
            }
          }}
        />
      </div>
    </section>
  );
};
